import { FC } from 'react';

import { GridColumn, GridRow } from '@hh.ru/magritte-ui';

import { ProfessionScrollAnchors } from 'src/models/pages/profession';

import Calculator from 'src/pages/Profession/components/SectionCalculator/Calculator';
import { CalculatorProvider } from 'src/pages/Profession/components/SectionCalculator/Context';
import SectionContainer from 'src/pages/Profession/components/SectionCalculator/SectionContainer';
import SelectedSkills from 'src/pages/Profession/components/SectionCalculator/SelectedSkills';

import styles from './styles.less';

const CalculatorSection: FC = () => (
    <CalculatorProvider>
        <div id={ProfessionScrollAnchors.Calculator} />
        <SectionContainer>
            <GridRow>
                <GridColumn xs={4} s={8} m={7}>
                    <div className={styles.calculatorContainer}>
                        <Calculator />
                    </div>
                </GridColumn>
                <GridColumn xs={4} s={8} m={5}>
                    <SelectedSkills />
                </GridColumn>
            </GridRow>
        </SectionContainer>
    </CalculatorProvider>
);

export default CalculatorSection;
